<template>
	<div class="container">
		<div v-if="data.show_title">
			<h3>{{ data?.title }}</h3>
		</div>
		  <div class="row">
			<div :class="itemSize(index)" v-for="(about, index) in this.data.data.items" :key="index" :data="about">
				<about-us-card :data="about"/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {PageComponentInterface} from "../Interfaces/PageComponentInterface";
import AboutUsCard from "../../../Components/AboutUs/AboutUsCard.vue";

export default defineComponent({
	name: "AboutUsPageSection",
	components: {AboutUsCard},
	props: {
		data: {
			type: Object as PropType<PageComponentInterface>,
			required: true,
		}
	},
	methods: {
		itemSize(index: any) {
			const itemsLength = this.data.data.items.length ?? 4;
			const itemsPerRow = Math.min(itemsLength, 4);
			const rows = Math.ceil(itemsLength / itemsPerRow);
			const currentRow = Math.floor(index / itemsPerRow) + 1;
			const itemsInCurrentRow = (currentRow === rows) ? itemsLength - (currentRow - 1) * itemsPerRow : itemsPerRow;
			return `col-lg-${Math.floor(12 / itemsInCurrentRow)}`;
		}
	}
});
</script>

<style scoped>
</style>
